export default __webpack_public_path__ + "static/media/Home-ComoPedir.c1a9f750.png";